import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import PdfBtn from './PdfBtn'
import SectionResult from './SectionResult'

import sections from '../data/sections'

const ResultsPage = ({ scoredSectionData, scoredSubSections }) => {
    useEffect(() => {
        document.getElementById("top-anchor").scrollIntoView({behavior:"smooth"})
      }, [])

    return (
        <div className="grid-container page">
            <div className="clear"></div>
            <div className="grid-x">
                <div className="results-intro cell small-12 large-8">
                    <h3 className="bold">My Results</h3>
                    <p className="no-print">
                        Your results will appear on this page as you complete each key component of the readiness assessment.
                    </p>
                    <p className="print-only">These are your results from the Telehealth Readiness Assessment. Please visit mhcc.maryland.gov for more information.</p>
                    { !scoredSectionData && <p>Use the Concept Menu above to get started.</p> }
                </div>

                <div className="all-guidance--results btn-group no-print">
                    <PdfBtn link="/Telehealth-Readiness-Guidance.pdf" btnText="Download All Guidance"></PdfBtn>
                    <button className="btn pdf-btn no-print print-btn" onClick={() => {
                        gtag('event', 'Print results', {
                            'event_category': 'download'
                        })
                        window.print()
                    }}>
                        Print My Results                        
                        <svg className="pdf-icon" viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                            <g>
                                    <path d="M448,192 L448,77.25 L370.74,0 L96,0 L64,32 L64,192 C28.65,192 0,220.65 0,256 L0,384 L64,384 L64,480 L96,512 L416,512 L448,480 L448,384 L512,384 L512,256 C512,220.65 483.35,192 448,192 Z M417,482 L94,482 L94,340 L417,340 L417,482 Z M417,220 L94,220 L94,30 L336.25,30 L336.25,106 L417,106 L417,220 Z M458,267 C444.75,267 434,256.25 434,243 C434,229.74 444.75,219 458,219 C471.25,219 482,229.74 482,243 C482,256.25 471.25,267 458,267 Z"></path>
                            </g>
                        </svg>
                    </button>
                </div>
            </div>

            <div className="section-results-list no-print-vertical-margin">
                {!!scoredSectionData && scoredSectionData.map((section) => 
                    <SectionResult firstSubSection={ section.subSections[0] } section={ section } subSectionScores={ scoredSubSections.filter((subSection) => subSection.section === section.secId) } key={ section.secId } />
                )}
            </div>
        </div>
    )
}

const mapStateToProps = (state, props) => {
    const scoredSections = Object.keys(state.scores.sections)
    const scoredSubSections = Object.values(state.scores.subSections).filter((subSection) => subSection.score != null)

    return {
        scoredSectionData: (scoredSections.length === 0) ? undefined : sections.filter((section) => scoredSections.includes(section.secId)),
        scoredSubSections
    }
}

export default connect(mapStateToProps)(ResultsPage)


// WEBPACK FOOTER //
// ./src/components/ResultsPage.js